export default {
    url: '/licence',
    template: `
        <courses-courses-edit-version-edit-licence
            course-version="vm.courseVersion"
            licences="vm.licences"
            can-manage-course="vm.canManageCourse"
            course="vm.course"
        />`,
    resolve: {
        licences: (LicenceResource, course) => {
            return LicenceResource.query({
                courseId: course.id,
                pageSize: 0
            }).$promise;
        }
    },
    controller ($scope, licences, course, CourseService) {
        this.courseVersion = $scope.$parent.vm.courseVersion;
        this.licences = licences;
        this.course = course;
        this.canManageCourse = CourseService.canManageCourse(course);
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/version/edit/licence/index.js